import React from "react";
import ViewLineage from "./ViewLineage";

const LineageModal = ({
  showLineageModal,
  selectedLineageForView,
  setShowLineageModal,
  setSelectedLineageForView,
}) => {
  if (!showLineageModal || !selectedLineageForView) return null;

  return (
    <div className="fixed inset-0 m-0 p-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg shadow-xl w-[90vw] h-[90vh] overflow-hidden">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Data Lineage</h2>
          </div>
          <button
            onClick={() => {
              setShowLineageModal(false);
              setSelectedLineageForView(null);
            }}
            className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-full"
            title="Close"
          >
            <svg
              className="h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-[8px] overflow-y-auto h-[calc(90vh-80px)]">
          <div className="flex items-center justify-center h-full">
            <ViewLineage contractData={selectedLineageForView} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LineageModal;

